(function () {
  const STORAGE_KEY = 'newcop_size_system';
  const DEFAULT = 'eu';

  function read() {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      return v === 'us' ? 'us' : DEFAULT;
    } catch (e) {
      return DEFAULT;
    }
  }

  function applySizeValues(scope) {
    const current = read();
    const root = scope || document;
    const nodes =
      root.nodeType === 1 && root.matches && root.matches('.size-value[data-size-eu]')
        ? [root]
        : (root.querySelectorAll ? root.querySelectorAll('.size-value[data-size-eu]') : []);
    nodes.forEach((el) => {
      const value = current === 'us' ? el.getAttribute('data-size-us') : el.getAttribute('data-size-eu');
      if (value != null) el.textContent = value;
    });
  }

  function applyToPdpTabs() {
    const current = read();
    document.querySelectorAll('.product-form__variant-tab').forEach((tabGroup) => {
      const tabs = tabGroup.querySelectorAll('.product-form__variant-tab-select');
      let matched = false;
      tabs.forEach((tab) => {
        if (tab.getAttribute('data-tab-select') === current) {
          tab.classList.add('tab-active');
          matched = true;
        } else {
          tab.classList.remove('tab-active');
        }
      });
      if (matched) {
        const parent = tabGroup.closest('.product-form__variant');
        if (parent) {
          parent.querySelectorAll('.label-variant-box').forEach((labelVariant) => {
            const showEl = labelVariant.querySelector(`.variant-label.variant-${current}`);
            const hideEl = labelVariant.querySelector(`.variant-label.variant-${current === 'eu' ? 'us' : 'eu'}`);
            if (showEl) showEl.classList.remove('hidden');
            if (hideEl) hideEl.classList.add('hidden');
          });
        }
      }
    });
  }

  window.NewcopSizeSystem = {
    get: read,
    set(value) {
      const normalized = value === 'us' ? 'us' : 'eu';
      try {
        localStorage.setItem(STORAGE_KEY, normalized);
      } catch (e) {
        // ignore quota / privacy mode
      }
      applySizeValues();
    },
    apply: applySizeValues,
  };

  function init() {
    applyToPdpTabs();
    applySizeValues();

    if (typeof MutationObserver === 'undefined') return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          applySizeValues(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
